import { Store } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import createRootReducer, { IRootState } from "./CombineReducer";

export const getStore = (): Store<IRootState> =>
  configureStore({
    reducer: createRootReducer(),
  });
